let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bMkDm")).then(() => parcelRequire('5BAbe'));